import React from 'react'
import Style from '../../styles/privacy/privacy.module.scss'
import Header from '../../common/terms-policy/header'
import Footer from '../../common/terms-policy/footer'

const index = () => {
    return (
        <>
            <Header />
            <div className={Style.main}>
                <div>
                    <h1>Cookie Policy for Quizwall</h1>
                    <br />
                    This is the Cookie Policy for Quizwall, accessible from quizwall.io
                    <br />
                    <h3>What Are Cookies</h3>
                    <br />

                    <p>As is common practice with almost all professional websites this site uses cookies, which are tiny files that are downloaded to your computer, to improve your experience. This page describes what information they gather, how we use it and why we sometimes need to store these cookies. We will also share how you can prevent these cookies from being stored however this may downgrade or 'break' certain elements of the sites functionality.</p>
                    <br />
                    <h3>How We Use Cookies</h3>
                    <br />
                    <p>We use cookies for a variety of reasons detailed below. Unfortunately in most cases there are no industry standard options for disabling cookies without completely disabling the functionality and features they add to this site. It is recommended that you leave on all cookies if you are not sure whether you need them or not in case they are used to provide a service that you use.</p>
                    <br />
                    <h3>Disabling Cookies</h3>
                    <br />
                    <p>You can prevent the setting of cookies by adjusting the settings on your browser (see your browser Help for how to do this). Be aware that disabling cookies will affect the functionality of this and many other websites that you visit. Disabling cookies will usually result in also disabling certain functionality and features of the this site. Therefore it is recommended that you do not disable cookies. This Cookies Policy was created with the help of the Cookies Policy Generator.</p>
                    <br />
                    <h3>Account related cookies</h3>
                    <br />
                    <p>If you create an account with us then we will use cookies for the management of the signup process and general administration. These cookies will usually be deleted when you log out however in some cases they may remain afterwards to remember your site preferences when logged out.</p>


                    <br />
                    <h3>Login related cookies</h3>
                    <br />
                    <p>We use cookies when you are logged in so that we can remember this fact. This prevents you from having to log in every single time you visit a new page. These cookies are typically removed or cleared when you log out to ensure that you can only access restricted features and areas when logged in.</p>





                    <br />
                    <h3>The Cookies We Set
                    </h3>
                    <br />
                    <ul>
                        <li>
                            Account related cookies</li>
                        <br />
                        <p>If you create an account with us then we will use cookies for the management of the signup process and general administration. These cookies will usually be deleted when you log out however in some cases they may remain afterwards to remember your site preferences when logged out.</p>

                        <br />
                        <li>
                            Login related cookies
                        </li>
                        <br />
                        <p>We use cookies when you are logged in so that we can remember this fact. This prevents you from having to log in every single time you visit a new page. These cookies are typically removed or cleared when you log out to ensure that you can only access restricted features and areas when logged in.</p>

                    </ul>


                    <br />
                    <h3>Third Party Cookies</h3>
                    <br />
                    <p>In some special cases we also use cookies provided by trusted third parties. The following section details which third party cookies you might encounter through this site.</p><br /><p>
                        <ul>
                            <li>
                                This site uses Google Analytics which is one of the most widespread and trusted analytics solution on the web for helping us to understand how you use the site and ways that we can improve your experience. These cookies may track things such as how long you spend on the site and the pages that you visit so we can continue to produce engaging content.
                            </li>
                    <br/>
                            <li>
                                For more information on Google Analytics cookies, see the official Google Analytics page.

                                We also use social media buttons and/or plugins on this site that allow you to connect with your social network in various ways. For these to work the following social media sites including, will set cookies through our site which may be used to enhance your profile on their site or contribute to the data they hold for various purposes outlined in their respective privacy policies.
                            </li>
                        </ul>
                        </p>


                        <h3>More Information</h3>
                        <br/>

                    




                    <p>Hopefully that has clarified things for you and as was previously mentioned if there is something that you aren't sure whether you need or not it's usually safer to leave cookies enabled in case it does interact with one of the features you use on our site.</p>
                    <br/>

                        <p>For more general information on cookies, please read the Cookies Policy article.</p>

                        <br/><p>However if you are still looking for more information then you can contact us through one of our preferred contact methods:</p>
                        <br/>
                       <p>Email:- <a href="mailto:info.quizwallofficial@gmail.com">info.quizwallofficial@gmail.com</a></p>
                    
                </div>
            </div>
            <Footer />
        </>
    )
}

export default index